import React, { useContext, useEffect, useState } from 'react'
import { ButtonHeading } from 'components'
import { constant } from 'constants/constant';
import Tab from 'components/common/Tab';
import Freight from './Freight';
import DispatchDetails from './DispatchDetails';
// import GPS from './GPS';
import ConsignorFreight from './ConsignorFreight';
import Revenue from './Revenue';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getDispatchedTrip, getLastTrip, getUserPermissionApi } from '_services';
import StorageService from 'utils/StorageServices/StorageServices';
import { UserContext } from 'context';
import Loading from 'pages/Loading';
import { BiltyPrintModal, DriverTripReport, EndTripModal, SupplierTripReport } from 'modals';
import toast from 'react-hot-toast';
import ConfirmModalFor from "modals/ConfirmModalFor";
import SimTracking from './SimTracking';
import NewGpsTimeline from 'pages/Dashboard/NewGpsTimeline';
import { MainDetailsGPS } from '.';
import useDocumentTitle from 'hooks/useDocumentTitle';
import InterFirmFreight from './InterFirmFreight';

const TripDetail = () => {
  const { setGlobTripDetails, globTripDetails, setUserSettingPermission, settingChild } = useContext(UserContext)
  const settingChildGPS = settingChild?.find((i) => i?.label === "GPS Integration");
  const { id } = useParams()
  const navigate = useNavigate()
  useDocumentTitle("Trip Details | T360");
  // const [activeTab, setActiveTab] = useState(1);
  const [tripDetais, setTripDetails] = useState();
  const [userPermission, setUserPermission] = useState('')
  const [endTrip, setEndTrip] = useState(false);
  const [showEndTrip, setShowEndTrip] = useState(false);
  const [lastTripDetails, setLastTripDetails] = useState();
  const [show, setShow] = useState(false)
  const [tripReportShow, setTripReportShow] = useState(false)
  const [tripDriverReportShow, setTripDriverReportShow] = useState(false)
  const [endTripApiCall, setEndTripApiCall] = useState("")
  const [showBackModal, setShowBackModal] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [showOffEditOfcanvas, setShowEditOfcanvas] = useState(false);
  const [tripUpdateLoading, setTripUpdateLoading] = useState(false)

  const tabKey = searchParams.get("t") || `dispatched/${id}`;

  const activeTabObj = constant.tripDetailsTabs.find(tab => tab.value === tabKey);
  const activeTab = activeTabObj ? activeTabObj.id : 1;

  const callBackTab = (data) => {
    const selectedTab = constant.tripDetailsTabs.find(tab => tab.id === data);
    if (selectedTab) {
      setSearchParams({ t: selectedTab.value });
    }

  }
  const tabProps = {
    tabList: settingChildGPS?.available === 1 ? (tripDetais?.interfirm == 1 ? constant.tripDetailsTabs : constant?.tripDetailsTabs?.filter((f) => f?.value != "inter_firm")) : constant?.tripDetailsTabs?.filter((f) => f?.value != "gps"),
    callBackTab: callBackTab,
    activeTab: activeTab
  }

  useEffect(() => {
    if (id) {
      getDispatchedTripHandler(id);
    }
    getUserPermission(StorageService.getCompanyId())
  }, [id]);

  useEffect(() => {
    if (endTrip) {
      vehicleStatusCheck();
    }
  }, [endTrip]);

  const vehicleStatusCheck = () => {

    setLastTripDetails("");
    getLastTripHandle();
    setShowEndTrip(true);
  };

  const getLastTripHandle = async () => {
    const res = await getLastTrip({
      company_id: StorageService.getCompanyId(),
      vehicle_id: tripDetais?.vehicle_id?._id,
    });
    if (res?.responseCode === 200) {
      setLastTripDetails(res.data?.trip);
    } else {
      toast.error(res?.responseMessage);
    }
  };

  const getDispatchedTripHandler = async (tripId) => {
    try {
      const res = await getDispatchedTrip({
        company_id: StorageService.getCompanyId(),
        trip_id: tripId,
      });

      if (res?.responseCode === 200) {
        setTripDetails(res?.data?.trip);
        setGlobTripDetails(res?.data?.trip)
        setEndTripApiCall("")
      } else {
      }
    } catch (error) {
    }
  };

  const getUserPermission = async () => {
    try {
      const res = await getUserPermissionApi({
        company_id: StorageService.getCompanyId(),
      });
      if (res?.responseCode === 200) {
        setUserPermission(res?.data?.user);
        setUserSettingPermission(res?.data?.user)

      } else {
      }
    } catch (error) {
    }
  }


  const callApi = () => {
    getDispatchedTripHandler(id);
  }

  const callBackEnd = (data) => {
    setEndTripApiCall("call")
    callApi();
  };

  const submitLeaveModalProps = () => {
    setShowBackModal(false)
    // navigate(`/account/branch/details/${tripDetais?.branch_id?._id}?tab=3`)
    navigate(`/account/branch/details/${tripDetais?.branch_id?._id}?type=${constant.m_type.branch}&tab=${3}&search=${tripDetais?.branch_id?.branch}&offset=${1}&total_record=${25}&is_list=${true}`)
  }

  const freightProps = {
    freightId: id,
    tripDetais: tripDetais,
    callApi: callApi,
    userPermission: userPermission,
    setEndTripApiCall: setEndTripApiCall,
    endTripApiCall: endTripApiCall,
    activeTabDetail: activeTab
  }

  const DispatchDetailsProps = {
    freightId: id,
    tripDetais: tripDetais,
    callApi: callApi,
    userPermission: userPermission,
    setEndTripApiCall: setEndTripApiCall,
    endTripApiCall: endTripApiCall,
    setShowEditOfcanvas,
    showOffEditOfcanvas,
    setTripUpdateLoading,
    tripUpdateLoading

  }
  let builtyPrintModal = {
    isOpen: show,
    closeModal: (e) => setShow(false),
    modalMainClass: "_dashCommon_Modal _printViewModal _xxlModal",
    footerPart: true,
    modalTitle: "Print LR/ Bilty",
    submitTitle: "Print Bilty",
    therdSubmitTitle: "Download",
    freightId: id,
    tripDetais: tripDetais,
    confirmBox: (e) => setShowBackModal(true)
  }

  let TripReoprtModal = {
    isOpen: tripReportShow,
    closeModal: (e) => setTripReportShow(false),
    modalMainClass: "_dashCommon_Modal _printViewModal _xxlModal",
    footerPart: true,
    modalTitle: "Supplier Trip Report",
    submitTitle: "Download",
    therdSubmitTitle: "Download",
    freightId: id,
    tripDetais: tripDetais,
    // confirmBox: (e) => setShowBackModal(true)
  }


  let driverTripReoprtPrps = {
    isOpen: tripDriverReportShow,
    closeModal: (e) => setTripDriverReportShow(false),
    modalMainClass: "_dashCommon_Modal _printViewModal _xxlModal",
    footerPart: true,
    modalTitle: "Driver Trip Report",
    submitTitle: "Download",
    therdSubmitTitle: "Download",
    freightId: id,
    tripDetais: tripDetais,
    // confirmBox: (e) => setShowBackModal(true)
  }

  let endTripModal = {
    isOpen: showEndTrip,
    closeModal: (e) => {
      setShowEndTrip(false);
      setEndTrip(false);
    },
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "End Trip",
    submitTitle: "End Trip",
    callBackEnd: callBackEnd,
    lastTripDetails: lastTripDetails,

  };

  const backModalProps = {
    show: showBackModal,
    closeModal: (e) => setShowBackModal(false),
    title: "Information",
    submitTitle: "Add Format",
    onSubmit: submitLeaveModalProps,
    confirmModal: "confirmModal",

  };

  const handleBack = () => {

    callApi()
    // setIsDisabled(true)
    navigate("/trip/addtrip")

  }

  const editTripHandle = () => {
    setShowEditOfcanvas(true)
  }


  return (
    <div>

      <ButtonHeading
        title={"Trip detail"}
        printButtonTitle={tripDetais?.lr_list?.length > 0 ? 'Print Builty/LR' : ""}
        printOnClick={() => setShow(!show)}
        tripDetais={tripDetais}
        endTripTitle={tripDetais?.trip_status != 5 ? "End Trip" : ""}
        endTripOnClick={() => setEndTrip(true)}
        supplierTitle={tripDetais?.vehicle_ownership == 2 ? 'Supplier Report' : "Driver Report"}
        supplierOnClick={() => { tripDetais?.vehicle_ownership == 2 ? setTripReportShow(!show) : setTripDriverReportShow(!show) }}
        handleBack={handleBack}
        editOnClick={activeTab === 1 && editTripHandle}
        editButtonTitle="Edit Trip"
      />

      {tripDetais ? <div className='_trpDetail_bx'>
        <div className='addPr_flBx'>
          <Tab {...tabProps} />
          <div className={activeTab === 5 ? ' __mainGps_bx' : activeTab === 1 ? "__trpDetailsBx" : ' __navTabContents'} >
            {activeTab === 1 && (
              <DispatchDetails {...DispatchDetailsProps} />
            )}

            {activeTab === 2 && (
              <Freight {...freightProps} />
            )}

            {activeTab === 3 && (
              <ConsignorFreight {...freightProps} />
            )}

            {activeTab === 4 && (
              <Revenue {...freightProps} />
            )}

            {activeTab === 5 && (
              // <NewGpsTimeline {...freightProps}/>
              <MainDetailsGPS {...freightProps} />
            )}

            {activeTab === 6 && (
              <SimTracking {...freightProps} />
            )}

            {activeTab === 7 && (
              <InterFirmFreight {...freightProps} />
            )}

          </div>

        </div>

        {show
          && (
            <BiltyPrintModal {...builtyPrintModal} />
          )
        }

        {tripReportShow
          && (
            <SupplierTripReport {...TripReoprtModal} />
          )
        }
        {tripDriverReportShow
          && (
            <DriverTripReport {...driverTripReoprtPrps} />
          )
        }
        {showEndTrip && <EndTripModal {...endTripModal} />}
        {showBackModal && (
          <ConfirmModalFor {...backModalProps}>
            <>
              <p className="_confirmPrx">You don't have any format.</p>
            </>
          </ConfirmModalFor>
        )}

      </div> : <div className="loaderBg" style={{ textAlign: "center" }}><Loading /></div>}

    </div>
  )
}

export default TripDetail